import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUser,
  faCog,
  faUsers,
  faAddressCard,
  faPhoneAlt,
  faEnvelope,
  faAddressBook,
  faList
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faUser,
  faCog,
  faUsers,
  faAddressCard,
  faPhoneAlt,
  faEnvelope,
  faAddressBook,
  faList
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
